import { supabase } from '@/lib/supabase';

export const SUPPLIER_TYPES = [
  ['materials_supplier', 'Materials supplier'], ['subcontractor', 'Subcontractor'], ['plant_hire', 'Plant hire'],
  ['professional_services', 'Professional services'], ['labour_agency', 'Labour agency'], ['utility', 'Utility'], ['other', 'Other'],
];
export const CONTACT_TYPES = ['general', 'purchasing', 'accounts', 'deliveries', 'technical', 'management'];
export const PAYMENT_TERMS = [['net_days', 'Net days'], ['end_of_month_plus', 'End of month +'], ['pro_forma', 'Pro forma'], ['on_receipt', 'On receipt'], ['cash', 'Cash']];
export const DOC_TYPES = [
  ['insurance_employers_liability', "Employer's liability"], ['insurance_public_liability', 'Public liability'], ['insurance_contractors_all_risks', 'Contractors all risks'],
  ['insurance_motor', 'Motor'], ['insurance_professional_indemnity', 'Professional indemnity'], ['safety_statement', 'Safety statement'],
  ['tax_clearance', 'Tax clearance'], ['rct_registration', 'RCT registration'], ['method_statement', 'Method statement'], ['certification', 'Certification'], ['other', 'Other'],
];

export const isMissingSchema = (err) => /relation|does not exist|schema cache|Could not find/i.test(err?.message || '');

export async function listSuppliers(organisationId, { financial }) {
  if (financial) {
    const { data, error } = await supabase.from('suppliers')
      .select('*, supplier_entities(id, legal_name, trading_name, supplier_types, cro_number, vat_number, general_phone, general_email, town, county)')
      .eq('organisation_id', organisationId).order('created_at', { ascending: false });
    if (error) throw error;
    return data.map((s) => ({ ...s, entity: s.supplier_entities, display_name: s.supplier_entities?.trading_name || s.supplier_entities?.legal_name }));
  }
  const { data, error } = await supabase.from('v_suppliers_basic').select('*').eq('organisation_id', organisationId).order('display_name');
  if (error) throw error;
  return data.map((s) => ({ ...s, entity: { id: s.entity_id, legal_name: s.legal_name, trading_name: s.trading_name, supplier_types: s.supplier_types, general_phone: s.general_phone, general_email: s.general_email, town: s.town, county: s.county } }));
}

export async function getSupplier(supplierId, { financial }) {
  const list = financial
    ? await supabase.from('suppliers').select('*, supplier_entities(*)').eq('id', supplierId).single()
    : await supabase.from('v_suppliers_basic').select('*').eq('id', supplierId).single();
  if (list.error) throw list.error;
  const s = list.data;
  const entity = financial ? s.supplier_entities : { id: s.entity_id, legal_name: s.legal_name, trading_name: s.trading_name, supplier_types: s.supplier_types, general_phone: s.general_phone, general_email: s.general_email, address_line1: s.address_line1, address_line2: s.address_line2, town: s.town, county: s.county, eircode: s.eircode };
  return { ...s, entity, display_name: entity.trading_name || entity.legal_name };
}

export async function createSupplier({ organisationId, legalName, tradingName, croNumber, vatNumber, supplierTypes, categories }) {
  const { data, error } = await supabase.rpc('create_supplier', {
    _organisation_id: organisationId, _legal_name: legalName, _trading_name: tradingName || null, _cro_number: croNumber || null,
    _vat_number: vatNumber || null, _supplier_types: supplierTypes || [], _categories: categories || [],
  });
  if (error) throw error;
  return data;
}

export async function updateSupplier(id, patch) {
  const { data, error } = await supabase.from('suppliers').update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}
export async function updateEntity(id, patch) {
  const { data, error } = await supabase.from('supplier_entities').update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

const simple = (table) => ({
  list: async (entityId, col = 'entity_id') => { const { data, error } = await supabase.from(table).select('*').eq(col, entityId).order('created_at'); if (error) throw error; return data; },
  insert: async (row) => { const clean = Object.fromEntries(Object.entries(row).filter(([, v]) => v !== '' && v != null)); const { data, error } = await supabase.from(table).insert(clean).select().single(); if (error) throw error; return data; },
  update: async (id, patch) => { const { data, error } = await supabase.from(table).update(patch).eq('id', id).select().single(); if (error) throw error; return data; },
});
export const contacts = simple('supplier_contacts');
export const branches = simple('supplier_branches');
export const documents = simple('supplier_documents');
export const notes = simple('supplier_notes');

export async function uploadSupplierDocument({ entityId, file }) {
  const path = `${entityId}/${Date.now()}-${file.name.replace(/[^\w.\-]+/g, '_')}`;
  const { error } = await supabase.storage.from('supplier-docs').upload(path, file, { upsert: false });
  if (error) throw error;
  return path;
}
export async function signedDocUrl(path) {
  const { data, error } = await supabase.storage.from('supplier-docs').createSignedUrl(path, 120);
  if (error) throw error;
  return data.signedUrl;
}

export async function priceLists(supplierId) {
  const { data, error } = await supabase.from('supplier_price_lists').select('*').eq('supplier_id', supplierId).order('effective_from', { ascending: false });
  if (error) throw error;
  return data;
}
export async function insertPriceList(row) {
  const clean = Object.fromEntries(Object.entries(row).filter(([, v]) => v !== '' && v != null));
  const { data, error } = await supabase.from('supplier_price_lists').insert(clean).select().single();
  if (error) throw error;
  return data;
}
